import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      meta: { title: "Мета" },
      path: "edit/1",
      component: () => import("@/views/forms/HubMetaForm.vue"),
    },
    {
      path: "elements",
      component: Forward,
      meta: { title: "Элементы" },
      redirect: `${rootPath}/elements/list`,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/HubTable.vue"),
          meta: { title: "Список элементов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/HubForm.vue"),
          meta: { title: "Создать элемент", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/HubForm.vue"),
          meta: { title: "Редактировать элемент", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
